import React, { useState } from "react";
import { RotateCcw, ImageOff, Image as ImageIcon } from "lucide-react";
import { useLanguage } from "../../contexts/LanguageContext";

const URL_RE = /^https?:\/\/.+/;

const UrlField = ({ label, value, onChange, placeholder }) => {
  const { translate } = useLanguage();
  const [imgError, setImgError] = useState(false);
  const isValid = !value || URL_RE.test(value);
  const showThumbnail = value && !imgError && isValid;
  const showBroken = value && (imgError || !isValid);
  const isDirty = value !== null && value !== undefined && value !== "";

  return (
    <div className="flex items-center gap-3 px-3 py-2.5 rounded-xl"
      style={{ backgroundColor: "var(--color-surface-raised)", border: "1px solid var(--color-border)" }}>
      <label className="flex-shrink-0 text-sm" style={{ color: "var(--color-text-primary)", width: "100px" }}>
        {label}
      </label>
      <div
        className="flex-shrink-0 w-8 h-8 rounded overflow-hidden flex items-center justify-center"
        style={{
          background: "var(--color-surface)",
          border: showThumbnail
            ? "1px solid var(--color-border)"
            : "1px dashed var(--color-border)",
        }}
      >
        {showThumbnail ? (
          <img
            src={value}
            alt=""
            className="w-full h-full object-cover"
            onError={() => setImgError(true)}
          />
        ) : showBroken ? (
          <ImageOff size={14} style={{ color: "var(--color-error)" }} />
        ) : (
          <ImageIcon size={14} style={{ color: "var(--color-text-muted)", opacity: 0.5 }} />
        )}
      </div>
      <input
        type="text"
        value={value || ""}
        onChange={(e) => {
          setImgError(false);
          onChange(e.target.value || null);
        }}
        placeholder={placeholder || "https://..."}
        className="field-input flex-1"
        style={{ fontSize: "13px", borderColor: !isValid ? "var(--color-error)" : undefined }}
      />
      {isDirty ? (
        <button
          type="button"
          onClick={() => { setImgError(false); onChange(null); }}
          title={translate("resetField") || "Reset to default"}
          className="p-1.5 rounded hover:bg-gray-100 transition-colors"
          style={{ color: "var(--color-text-muted)" }}
        >
          <RotateCcw size={14} />
        </button>
      ) : (
        <span className="p-1.5" style={{ width: 28, height: 28 }} aria-hidden="true" />
      )}
    </div>
  );
};

export default UrlField;
